import { render, staticRenderFns } from "./AppVehicleInfoVehiclesGroup.vue?vue&type=template&id=0b5f1e73&scoped=true&"
import script from "./AppVehicleInfoVehiclesGroup.vue?vue&type=script&lang=js&"
export * from "./AppVehicleInfoVehiclesGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppVehicleInfoVehiclesGroup.vue?vue&type=style&index=0&id=0b5f1e73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f1e73",
  null
  
)

export default component.exports